import React from "react";


import parseHTML from "html-react-parser";


import {
    Col
} from "react-bootstrap";


import "./index.scss";


type CardDescriptionComponentProps = {
    cardDescription: string;
};


export const CardDescriptionComponent:React.FC<CardDescriptionComponentProps> = ({
    cardDescription
}) => {

    if (!cardDescription) {
        return null;
    }

    return (
        <Col xs={12} className={`card-description-component`}>
            {parseHTML(cardDescription)}
        </Col>
    );

};


export default CardDescriptionComponent;
